// src/pages/OverviewTab.js
import React, { useEffect, useState } from "react";
import {
    SectionTitle,
    PlatformSection,
    PlatformHeaderRow,
    PlatformHeaderCell,
    PlatformRow,
    PlatformParentRow,
    PlatformInput,
    StatusBadge,
    NameCell,
    ParentTag,
    EmptyValue,
    SaveButton,
    DiscardButton,
    ChangeCountText,
} from "../style-comps/AdminPropertyPage.styles";
import { Dropdown } from "../components/Dropdown";
import { getListingPlatforms } from "../services/api";

const OverviewTab = ({
    listing,
    parentRow,
    setParentRow,
    childrenRows,
    setChildrenRows,
    onSave,
    onDiscard,
    isDirty,
    changedCount,
}) => {
    const [platformOptions, setPlatformOptions] = useState([]);

    const [platformsLoaded, setPlatformsLoaded] = useState(false);

    useEffect(() => {
        getListingPlatforms()
            .then((data) => {
                setPlatformOptions(data.map((p) => ({ label: p, value: p })));
                setPlatformsLoaded(true);   // 👈 加這個
            })
            .catch((err) => {
                console.error("❌ 無法取得 Platform 選項:", err);
                setPlatformsLoaded(true);   // 就算失敗也要解除 loading
            });
    }, []);

    useEffect(() => {
        getListingPlatforms()
            .then((data) => {
                setPlatformOptions(data.map((p) => ({ label: p, value: p })));
            })
            .catch((err) => {
                console.error("❌ 無法取得 Platform 選項:", err);
            });
    }, []);


    if (platformOptions.length === 0) return null;





    return (
        <>
            {/* ========== Platform Section ========== */}
            <PlatformSection>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                    {isDirty && (
                        <>
                            <ChangeCountText>
                                {changedCount} items change
                            </ChangeCountText>
                            <DiscardButton onClick={onDiscard}>Discard</DiscardButton>
                            <SaveButton onClick={onSave}>Save</SaveButton>
                        </>
                    )}
                </div>

                <PlatformHeaderRow>
                    <PlatformHeaderCell>KozyGuru Name</PlatformHeaderCell>
                    <PlatformHeaderCell>Platform Name</PlatformHeaderCell>
                    <PlatformHeaderCell>Link</PlatformHeaderCell>
                    <PlatformHeaderCell>Status</PlatformHeaderCell>
                    <PlatformHeaderCell>Listed</PlatformHeaderCell>
                    <PlatformHeaderCell>Booking Engine</PlatformHeaderCell>
                </PlatformHeaderRow>

                {/* ========== Parent Row ========== */}
                <PlatformParentRow>
                    <NameCell>
                        {parentRow.kozyguruName}
                        <ParentTag>Parent</ParentTag>
                    </NameCell>

                    <Dropdown
                        options={platformOptions}
                        value={parentRow.platform || ""}
                        onChange={(val) => setParentRow({ ...parentRow, platform: val })}
                        isOpen={parentRow.__dropdownOpen}
                        onOpen={() => setParentRow({ ...parentRow, __dropdownOpen: true })}
                        onClose={() => setParentRow({ ...parentRow, __dropdownOpen: false })}
                        disabled={!platformsLoaded}
                    />


                    <PlatformInput
                        value={parentRow.url || ""}
                        onChange={(e) => setParentRow({ ...parentRow, url: e.target.value })}
                    />

                    <StatusBadge
                        variant="status"
                        online={parentRow.isActive}
                        onClick={() =>
                            setParentRow({ ...parentRow, isActive: !parentRow.isActive })
                        }>
                        {parentRow.isActive ? "Online" : "Offline"}
                    </StatusBadge>

                    <StatusBadge variant="listed" online={parentRow.online} style={{ cursor: "default" }}>
                        {parentRow.online ? "Listed" : "Unlisted"}
                    </StatusBadge>

                    <StatusBadge
                        variant="booking"
                        online={parentRow.isPublishedToBookingEngine}
                        onClick={() =>
                            setParentRow({ ...parentRow, isPublishedToBookingEngine: !parentRow.isPublishedToBookingEngine })
                        }>
                        {parentRow.isPublishedToBookingEngine ? "Published" : "Unpublished"}
                    </StatusBadge>
                </PlatformParentRow>

                {/* ========== Children ========== */}
                <SectionTitle>Children</SectionTitle>

                {childrenRows.map((row, i) => (
                    <PlatformRow key={i}>
                        <NameCell>{row.kozyguruName}</NameCell>

                        <Dropdown
                            options={platformOptions}
                            value={row.platform || ""}
                            onChange={(val) => {
                                const updated = [...childrenRows];
                                updated[i] = { ...updated[i], platform: val };
                                setChildrenRows(updated);
                            }}
                            isOpen={row.__dropdownOpen}
                            onOpen={() => {
                                const updated = [...childrenRows];
                                updated[i].__dropdownOpen = true;
                                setChildrenRows(updated);
                            }}
                            onClose={() => {
                                const updated = [...childrenRows];
                                updated[i].__dropdownOpen = false;
                                setChildrenRows(updated);
                            }}
                            disabled={!platformsLoaded}
                        />

                        <PlatformInput
                            value={row.url || ""}
                            onChange={(e) => {
                                const updated = [...childrenRows];
                                updated[i] = { ...updated[i], url: e.target.value };
                                setChildrenRows(updated);
                            }}
                        />

                        <StatusBadge
                            variant="status"
                            online={row.isActive}
                            onClick={() => {
                                const updated = [...childrenRows];
                                updated[i] = { ...updated[i], isActive: !updated[i].isActive };
                                setChildrenRows(updated);
                            }}>
                            {row.isActive ? "Online" : "Offline"}
                        </StatusBadge>

                        <StatusBadge variant="listed" online={row.online} style={{ cursor: "default" }}>
                            {row.online ? "Listed" : "Unlisted"}
                        </StatusBadge>

                        <EmptyValue>—</EmptyValue>
                    </PlatformRow>
                ))}
            </PlatformSection>
        </>
    );
};

export default OverviewTab;